export const quickOrder = {
  quickOrderCartForm: {
    entriesWereAdded: '({{ quantity }}) {{ product }} has been added to the cart',
    entryWasAdded: '{{ product }} has been added to the cart',
    noResults: 'The catalog no. entered cannot be found. Please try with a different one.',
    stockLevelReached: 'The maximum number of items per product has been reached.',
    title: 'Quick Order - add more items easily!',
    productCodePlaceholder: 'Catalog no.',
    entryProductCode: 'Enter Catalog ID for Quick Order',
    quantity: 'Quantity for Quick Order',
    addToCart: 'Add Product to Quick Order',
    add: 'Add to cart',
    product: 'Product',
    products: 'Products',
    productCodeLabel: 'Product ID',
    quantityLabel: 'Qty',
  }
}
